module.exports = __webpack_public_path__ + "img/xls.e8ee0f3e.svg";